import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setDate({ commit }, data) {
    commit(types.SET_DATE, data)
  },
  setView({ commit }, data) {
    commit(types.SET_VIEW, data)
  },
  setAllFirms({ commit }, data) {
    commit(types.SET_ALL_FIRMS, data)
  },
  setFirms({ commit }, data) {
    commit(types.SET_FIRMS, data)
  },
  resetDashboard({ commit }) {
    commit(types.RESET_DASHBOARD)
  },
  resetEvaluation({ commit }) {
    commit(types.RESET_EVALUATION)
  },
  setAiLoading({ commit }, data) {
    commit(types.SET_AI_LOADING, data)
  },
  async getDashboard({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get(`dashboard/dashboard?firm=${data.firm}&startDate=${data.startDate}&endDate=${data.endDate}`)
    )
    commit(types.SET_DASHBOARD, r.data)
    return r.data
  },
  async getDashboardTop({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDashboardTop', () =>
      http.get(`dashboard/dashboardTop?firm=${data.firm}&startDate=${data.startDate}&endDate=${data.endDate}`)
    )
    commit(types.SET_DASHBOARDTOP, r.data)
    return r.data
  },
  async getAdasRecords({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasRecords', () =>
      http.get('dashboard/adasRecords', {
        params: options
      })
    )
    if (!options.type) {
      commit(types.SET_ADASRECORDS, r.data)
    }
    return r.data
  },
  async getCounts({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCounts', () => http.get(`dashboard/counts?startDate=${data.startDate}&endDate=${data.endDate}`))
    commit(types.SET_COUNTS, r.data)
    return r.data
  },
  async getTopStats({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getTopStats', () =>
      http.get('dashboard/topStats', {
        params: options
      })
    )
    commit(types.SET_TOPSTATS, r.data)
    return r.data
  },
  async failedVINs({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'failedVINs', () => http.get(`admin/failedVINs?startDate=${data.startDate}&endDate=${data.endDate}`))
    commit(types.SET_FAILEDVINS, r.data)
    return r.data
  },
  async evaluateRecords({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'evaluateRecords', () =>
      http.get(`admin/evaluateRecords?adas=${data.adas}&repair=${data.repair}&vin=${data.vin}&adasInspection=${data.adasInspection}`)
    )
    commit(types.SET_EVALUATION, r.data)
    return r.data
  },
  async getBMS({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getBMS', () => http.get(`admin/getBMS?uniqueId=${id}`))
    commit(types.SET_BMS, r.data)
    return r.data
  },
  async getBMSHistory({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getBMSHistory', () => http.get(`admin/getBMSHistory?uniqueId=${id}`))
    let data = r.data
    if (typeof data === 'string') {
      try { data = JSON.parse(data) } catch (e) { data = [] }
    }
    commit(types.SET_BMS_HISTORY, data)
    return data
  },
  resetBMSHistory({ commit }) {
    commit(types.RESET_BMS_HISTORY)
  },
  async getEmailLog({ commit, dispatch }, email) {
    commit(types.RESET_LOG)
    const r = await startLoading(dispatch, 'getEmailLog', () => http.get(`admin/getEmails?email=${email}`))
    commit(types.SET_EMAIL_LOG, r.data)
    return r.data
  },
  resetLog({ commit }) {
    commit(types.RESET_LOG)
  },
  setParameter({ commit }, data) {
    commit(types.SET_PARAMETER, data)
  },
  async getLog({ commit, dispatch }, data) {
    let r = null
    commit(types.RESET_LOG)
    let query = `query=Timestamp ge datetime'${data.startDate}' and Timestamp lt datetime'${data.endDate}'`
    r = await http.get(`log/queryLog?${query}`, {}, http.config, http.apiUrl)
    commit(types.SET_LOG, r.data)
    return r.data
  },
  async getInternalLog({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getInternalLog', () =>
      http.get('dashboard/internalLog', {
        params: options
      })
    )
    commit(types.SET_INTERNAL_LOG, r.data)
    return r.data
  },
  filterLog({ commit }, data) {
    commit(types.FILTER_LOG, data)
  },
  async getNoScrubLog({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getNoScrubLog', () =>
      http.get('log/entriesNoScrub', {
        params: options
      })
    )
    commit(types.SET_INTERNAL_LOG, r.data)
    return r.data
  },

  async getClientReview({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getClientReview', () =>
      http.get('dashboard/clientReview', {
        params: options
      })
    )
    commit(types.SET_CLIENTREVIEW, r.data)
    return r.data
  },
  async getClientInspections({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getClientInspections', () =>
      http.get('dashboard/clientInspections', {
        params: options
      })
    )
    commit(types.SET_CLIENTINSPECTIONS, r.data)
    return r.data
  },
  async getClientBreakdown({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getClientBreakdown', () =>
      http.get('dashboard/clientBreakdown', {
        params: data
      })
    )
    commit(types.SET_CLIENTBREAKDOWN, r.data)
    return r.data
  },
  // Not Used?
  async getDecodeStats({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDecodeStats', () =>
      http.get('dashboard/decodeStats', {
        params: data
      })
    )
    commit(types.SET_DECODESTATS, r.data)
    return r.data
  },
  async getFragmentation({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getFragmentation', () => http.get('admin/getIndexFragmentation'))
    commit(types.SET_FRAGMENTATION, r.data)
    return r.data
  },
  async getMissingIndexes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getMissingIndexes', () => http.get('admin/getMissingIndexes'))
    commit(types.SET_MISSING_INDEXES, r.data)
    return r.data
  },
  async aiPrompt({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'aiPrompt', () =>
      http.post('decode/ai', data)
    )
    commit(types.SET_AI_PROMPT, r.data)
    return r.data
  },
  resetQuote({ commit }) {
    commit(types.RESET_QUOTE)
  },
  async getQuote({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getQuote', () =>
      http.post('adas/quote', data)
    )
    commit(types.SET_QUOTE, r.data)
    return r.data
  },
  resetPredictive({ commit }) {
    commit(types.RESET_PREDICTIVE)
  },
  async getPredictive({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPredictive', () =>
      http.post('adas/predictiveAdas', data)
    )
    commit(types.SET_PREDICTIVE, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js